import { bool, shape, string } from 'prop-types'

const broadcastType = shape({
  id: string,
  title: string,
  state: string,
  type: string,
  streamerSaveUrl: string,
  streamDestination: string,
  streamDestination2: string,
  courtTopLeftLogoUrl: string,
  courtTopRightLogoUrl: string,
  courtBottomLeftLogoUrl: string,
  courtBottomRightLogoUrl: string,
  courtCenterLogoUrl: string,
  // Obsolete aliases — kept for backward compatibility, remove in second pass
  courtTopLeftLogo: string,
  courtTopRightLogo: string,
  courtBottomLeftLogo: string,
  courtBottomRightLogo: string,
  courtCenterLogo: string,
  isStreamedToYoutube: bool,
  isRecorded: bool,
  isCommentaryOn: bool,
  autoStart: bool,
  autoStop: bool,
})

export default broadcastType
